<template lang="pug">

ListAdminContact(:title="title")
</template>

  
  <script>
import ListAdminContact from "../components/ListAdminContact.vue";
export default {
  name: "ContactUs",
  components: {
    ListAdminContact,
  },
  data: () => ({
    title: "Contact Us",
  }),
};
</script>
  
  <style>
.v-main__wrap {
  background: #f3f3f4;
}

.v-application .blue {
  background-color: #01c8f1 !important;
  border-color: #01c8f1 !important;
}
</style>
  